import { render, staticRenderFns } from "./accordion-wrapper.vue?vue&type=template&id=60e6208c&"
import script from "./accordion-wrapper.vue?vue&type=script&lang=js&"
export * from "./accordion-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./accordion-wrapper.vue?vue&type=style&index=0&id=60e6208c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports